import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import MediaQuery from '../../../utils/mediaQuery';

export const SliderWrapper = styled(Box)`
  --slide-spacing: 1rem;
  width: calc(100% + 2rem);
  margin-left: -1rem;
  margin-right: -1rem;
  position: relative;

  .embla__viewport {
    width: 100%;
    overflow: hidden;
  }

  .embla__container {
    display: flex;
    margin-left: calc(var(--slide-spacing) * -1);
    padding-bottom: 1rem;
  }

  .embla__slide {
    flex: 0 0 calc(100% - 100px);
    min-width: 0;
    padding-left: var(--slide-spacing);
    padding-top: 1.25rem;
    padding-bottom: 0;
    display: flex;

    & > * {
      width: 100%;
    }
  }

  .embla__arrows {
    display: block;
    position: absolute;
    top: 50%;
    z-index: 10;
  }

  .embla__prev {
    left: 10px;
    transform: translateY(-50%);
  }

  .embla__next {
    right: 10px;
    transform: translateY(-50%);
  }

  .embla__dots {
    display: flex;
    justify-content: center;
    gap: 1rem;
    padding-bottom: 1rem;
  }

  ${MediaQuery.large`
    width: 100%;
    margin-left: 0;
    margin-right: 0;

    .embla__container {
      margin-left: 0;
      gap: 1.5rem;
    }

    .embla__slide {
      flex: 0 0 calc((100% - 3rem) / 3);
      padding-left: 0;
      padding-top: 2.75rem;
    }

    .embla__arrows {
      display: block;
    }

    .embla__prev {
      left: 0;
      transform: translateX(calc(-100% - 15px)) translateY(-50%);
    }

    .embla__next {
      right: 0;
      transform: translateX(calc(100% + 15px)) translateY(-50%);
    }
  `}
`;
